var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import preloadedCards from "../preloadedCards";
// Cache for card info to avoid repeated async calls
export var cardInfoCache = {};
// Cache for explainScoring results
export var explainScoringCache = {};
// Track which trumps are currently being prefilled to avoid duplicate requests
var prefillInProgressMap = {};
export function isPrefillInProgress(trump) {
    var trumpKey = getTrumpKey(trump);
    return (prefillInProgressMap[trumpKey] !== undefined &&
        prefillInProgressMap[trumpKey] !== null);
}
export function markPrefillStarted(trump, promise) {
    var trumpKey = getTrumpKey(trump);
    prefillInProgressMap[trumpKey] = promise;
}
function markPrefillCompleted(trump) {
    var trumpKey = getTrumpKey(trump);
    delete prefillInProgressMap[trumpKey];
}
export function getPrefillPromise(trump) {
    var trumpKey = getTrumpKey(trump);
    return prefillInProgressMap[trumpKey] || null;
}
// Helper to create a stable cache key from trump
export var getTrumpKey = function (trump) {
    if ("Standard" in trump) {
        return "std_".concat(trump.Standard.suit, "_").concat(trump.Standard.number);
    }
    else if ("NoTrump" in trump) {
        return "nt_".concat(trump.NoTrump.number || "none");
    }
    return "unknown";
};
// Prefill card info cache for all cards with a given trump using batch API
export var prefillCardInfoCache = function (engine, trump) { return __awaiter(void 0, void 0, void 0, function () {
    var trumpKey, existingPromise, prefillPromise;
    return __generator(this, function (_a) {
        trumpKey = getTrumpKey(trump);
        existingPromise = getPrefillPromise(trump);
        if (existingPromise) {
            // Prefill already in progress for this trump, return existing promise
            return [2 /*return*/, existingPromise];
        }
        prefillPromise = (function () { return __awaiter(void 0, void 0, void 0, function () {
            var requestsToMake, _i, preloadedCards_1, cardInfo, cacheKey, unknownCacheKey, batchResponse, error_1, _loop_1, _a, requestsToMake_1, _b, card, cacheKey;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestsToMake = [];
                        // Get all unique card values from preloadedCards
                        for (_i = 0, preloadedCards_1 = preloadedCards; _i < preloadedCards_1.length; _i++) {
                            cardInfo = preloadedCards_1[_i];
                            cacheKey = "".concat(cardInfo.value, "_").concat(trumpKey);
                            // Skip if already cached
                            if (cacheKey in cardInfoCache) {
                                continue;
                            }
                            requestsToMake.push({ card: cardInfo.value, cacheKey: cacheKey });
                        }
                        unknownCacheKey = "\uD83C\uDCA0_".concat(trumpKey);
                        if (!(unknownCacheKey in cardInfoCache)) {
                            requestsToMake.push({ card: "🂠", cacheKey: unknownCacheKey });
                        }
                        // If nothing to fetch, return early
                        if (requestsToMake.length === 0) {
                            // Card info cache already filled for this trump
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, engine.batchGetCardInfo({
                                requests: requestsToMake.map(function (r) { return ({
                                    card: r.card,
                                    trump: trump,
                                }); }),
                            })];
                    case 2:
                        batchResponse = _c.sent();
                        // Process batch response
                        // Validate response structure
                        if (!batchResponse ||
                            !batchResponse.results ||
                            !Array.isArray(batchResponse.results)) {
                            throw new Error("Invalid batch response structure: ".concat(JSON.stringify(batchResponse)));
                        }
                        if (batchResponse.results.length !== requestsToMake.length) {
                            console.warn("Response length mismatch: expected ".concat(requestsToMake.length, ", got ").concat(batchResponse.results.length));
                        }
                        // Store results in cache
                        batchResponse.results.forEach(function (info, index) {
                            if (index >= requestsToMake.length) {
                                console.warn("Skipping extra response at index ".concat(index));
                                return;
                            }
                            var cacheKey = requestsToMake[index].cacheKey;
                            cardInfoCache[cacheKey] = info;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        console.error("❌ Error batch fetching card info:", error_1);
                        console.error("Error details:", error_1 instanceof Error ? error_1.stack : error_1);
                        _loop_1 = function (card, cacheKey) {
                            var cardData = preloadedCards.find(function (c) { return c.value === card; });
                            cardInfoCache[cacheKey] = {
                                suit: null,
                                effective_suit: "Unknown",
                                value: card,
                                display_value: (cardData === null || cardData === void 0 ? void 0 : cardData.display_value) || card,
                                typ: (cardData === null || cardData === void 0 ? void 0 : cardData.typ) || "unknown",
                                number: (cardData === null || cardData === void 0 ? void 0 : cardData.number) || null,
                                points: (cardData === null || cardData === void 0 ? void 0 : cardData.points) || 0,
                            };
                        };
                        // Fallback to individual requests or static data
                        for (_a = 0, requestsToMake_1 = requestsToMake; _a < requestsToMake_1.length; _a++) {
                            _b = requestsToMake_1[_a], card = _b.card, cacheKey = _b.cacheKey;
                            _loop_1(card, cacheKey);
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); })();
        // Store the promise and set up cleanup
        markPrefillStarted(trump, prefillPromise);
        // Clear the in-progress flag when done
        prefillPromise.finally(function () {
            markPrefillCompleted(trump);
        });
        return [2 /*return*/, prefillPromise];
    });
}); };
// Create a cache key for explainScoring requests
export var getExplainScoringKey = function (params, smallerLandlordTeamSize, decks) {
    // Create a stable key based on the request parameters
    return JSON.stringify({
        params: params,
        smallerLandlordTeamSize: smallerLandlordTeamSize,
        deckCount: decks.length,
        // We assume deck configuration is the same for a given count
    });
};
// Prefill explainScoring cache
export var prefillExplainScoringCache = function (engine, params, decks) { return __awaiter(void 0, void 0, void 0, function () {
    var promises, _loop_2, _i, _a, smallerTeamSize;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                promises = [];
                _loop_2 = function (smallerTeamSize) {
                    var cacheKey = getExplainScoringKey(params, smallerTeamSize, decks);
                    if (cacheKey in explainScoringCache) {
                        return "continue";
                    }
                    var promise = engine
                        .explainScoring({
                        params: params,
                        smaller_landlord_team_size: smallerTeamSize,
                        decks: decks,
                    })
                        .then(function (result) {
                        explainScoringCache[cacheKey] = result;
                    })
                        .catch(function (error) {
                        console.error("Error prefilling explainScoring cache:", error);
                        // Fallback to empty result
                        explainScoringCache[cacheKey] = {
                            results: [],
                            step_size: 10,
                            total_points: 100,
                        };
                    });
                    promises.push(promise);
                };
                // Prefill both regular and bonus scoring
                for (_i = 0, _a = [false, true]; _i < _a.length; _i++) {
                    smallerTeamSize = _a[_i];
                    _loop_2(smallerTeamSize);
                }
                return [4 /*yield*/, Promise.all(promises)];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}); };
